import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b1k03395mh: FaireBrandEntity = {
  token: "b_b1k03395mh",
  type: "brand",
  name: "Oceanic Linkways Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/8371950b77b0719a528541aa4f65954a5c751e308aac6e619ba525278610e785.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/532d77fe7f698d0b74c55feccb986a0070dec70f45ebfd5b1d1262763efebf73.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8371950b77b0719a528541aa4f65954a5c751e308aac6e619ba525278610e785.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/532d77fe7f698d0b74c55feccb986a0070dec70f45ebfd5b1d1262763efebf73.png",
  location: "North Brunswick, NJ, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 57,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 1991, Oceanic Linkways is the premier wholesaler of Gemstones, Jewelry, Incense, Candle, Spiritual Gift, Home Decor, Gift Item, more. With sourcing in 19 countries, along with in-house design and production, Oceanic Linkways upholds it's mission of providing high quality products. www.oceaniclink.com",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.958Z",
    importedBy: "entity-db-cli",
  },
};
